import React,{useEffect, useState} from 'react'
import { Form } from 'react-bootstrap'
import axios from '../../axios'
import Toast from '../../Toast'
import './freeconsult.css'
import validator from 'validator'
import Loader from '../../Loader'
import allOverIndiaImg from '../assest/AllOverIndia.jpg'

const FreeConsult = () => {
  const [isLoading,setIsLoading] = useState(false)
  useEffect(() => {
    document.title = 'Contact-us'
  }, [])
  const addresses = [
    'R70, Sector 83, Manesar, Gurugram, Haryana 122012',
    'B/222B, Block B, Sushant Lok III, Sector 57, Gurugram, Haryana 122011',
    'A-16, Block K, South City II, Sector 49, Gurugram, Haryana 122018',
    '1NA, Ramgarh, Sector 67, Gurugram, Haryana 122101',
    '349, Block Q, South City I, Sector 40, Gurugram, Haryana 122003',
    '8, Rd No W 12, Phase 3, Sector 24, Dlf City Phase 3, Gurugram, Haryana 122002',
    '519, Huda, Sector 23, Gurugram, Haryana 122017',
    '629, Jyoti Park, Sector 7, Gurugram, Haryana 122001',
    '546B, Basai Enclave, Kadipur Industrial Area, Sector 37C, Gurugram, Haryana 122006',
    '06, Ward 30, Block B, Rajendra Park, Sector 105, Gurugram, Haryana 122006',
  ]
  const [contact,setContact] = useState({
    name:"",
        mobile:"",
        email:"",
        subject:"",
        message:""
})
const handleChange = (e) => {

  setContact({...contact,[e.target.name]:e.target.value})
}
const Contact_form = async(e)=>{
  const {name, mobile, email, subject, message} = contact
  e.preventDefault()

   if( !email || !message || !mobile ) return Toast("please fill properly")
   if( !validator.isEmail(email)) return Toast("email is not valid")
   if( !validator.isMobilePhone(mobile)) return Toast("mobile is not valid")
 

   try{
    setIsLoading(true)
    const response= await axios({
      method: "post",
     url:'/add_contact',
      data:{
        name,mobile,email,subject,message
      },

     })
     
     if(response.status===200){
      const data = response.data;
     
      Toast(data.message,response.status)
      
     }
   }
   catch(err){
    const error = err.response.data
    Toast(error.message)

   }
   finally{
    setIsLoading(false)
   }
}


    var arr =[
       
        {
            images:allOverIndiaImg,
            h1:"Global & Pan India",
            h6:"Production - Manager",
            p:[
              'Primepath International Movers Pvt Ltd is a professional and reputed relocation service provider based in Bangalore. Our main objective is to make the process of goods shifting relatively easy for you. We make sure that you have an unforgettable experience by minimizing all the worries related to goods shifting..'
            ]
        },

    ]
  return (
    <>
{isLoading && (<Loader />)}
<div
  className="about-us-top"
  style={{
    backgroundImage: 'url(images/faq.webp)',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  }}
>
        <h1>Free Consulting</h1>
      </div>
      {
        arr?.map((element,index)=>{
            
            return <div key={index} className="free-consulting-conatiner container " style={{flexDirection:'row-reverse'}}>
      <div style={{display: 'flex', alignItems:'center',justifyContent: 'center'}}>
        <img src={element?.images} id="free-consulting-img" alt="All over India" />
        </div>
        <div className='content-freeconsult'>
            <h2 >{element?.h1}</h2>
            {/* <h6>{element?.h6}</h6> */}
            <p>
          Thank you for your interest in Primepath International Movers Pvt Ltd Services. We value your inquiries, feedback, and suggestions. Our dedicated team is here to assist you with any questions you may have.
          </p>
            {element.p?.map((p_content)=>{

                return <p key={p_content}>{p_content}</p>             
            })}
            
          
        </div>
      </div>
        })
      }

      <div className="free-consulting-conatiner container " style={{flexDirection:'row-reverse'}}>
      <div style={{display: 'flex', alignItems:'center',justifyContent:'center'}}>
        <img src='images/women.webp' id="free-consulting-img" alt="Contact" />
        </div>
        <div className='content-freeconsult'>
        <h2>Contact Us</h2>
            <h6>Please share your feedback so we can improve.</h6>
            <Form className='free-consult-form' onSubmit={Contact_form}>
            <Form.Group className="mb-3" controlId="contactName">
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="Enter your name"
          name='name'
          value={contact.name}
          autoComplete="name"
          onChange={handleChange}
        />
      </Form.Group>

            <Form.Group className="mb-3" controlId="contactPhone">
        <Form.Label>Phone <span aria-hidden="true">*</span></Form.Label>
        <Form.Control
          type="tel"
          inputMode="numeric"
          placeholder="Enter your phone number"
          name='mobile'
          value={contact.mobile}
          autoComplete="tel"
          required
          onChange={handleChange}
        />
      </Form.Group>
            <Form.Group className="mb-3" controlId="contactSubject">
        <Form.Label>Subject</Form.Label>
        <Form.Control
          type="text"
          placeholder="Subject"
          name='subject'
          value={contact.subject}
          onChange={handleChange}
        />
      </Form.Group>

            <Form.Group className="mb-3" controlId="contactEmail">
        <Form.Label>Email <span aria-hidden="true">*</span></Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter your email"
          name='email'
          value={contact.email}
          autoComplete="email"
          required
          onChange={handleChange}
        />
      </Form.Group>
          
      <Form.Group className="mb-3" controlId="contactMessage">
        <Form.Label>Message <span aria-hidden="true">*</span></Form.Label>
        <Form.Control
          as="textarea"
          rows={6}
          name="message"
          value={contact.message}
          required
          placeholder="Write your message..."
          onChange={handleChange}
        />
      </Form.Group>

      <button className='btn-design mx-auto' type="submit" disabled={isLoading}>
        {isLoading ? 'Submitting...' : 'Submit'}
      </button>
            </Form>
        </div>
      </div>

      <div className='container free-consult-address-wrapper'>
        <div className='address-section'>
          <div className='address-title'>Our Addresses</div>
          <ul className='address-list'>
            {addresses.map((address) => (
              <li key={address} className='address-item'>
                <i className='bi bi-geo-alt-fill address-icon' aria-hidden="true" />
                <span className='address-text'>{address}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      
    </>
  )
}

export default FreeConsult